import * as React from 'react'

import harcourtsConnectLogo from 'app/assets/ucs-logos/harcourts-connect.jpg'

function SvgHarcourtsConnect(props) {
  return (
    <svg
      viewBox="0 0 80 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <path fill="url(#harcourts_connect_pattern)" d="M0 0h80v48H0z" />
      <defs>
        <pattern
          id="harcourts_connect_pattern"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#harcourts_connect_image"
            transform="scale(.004 .0067)"
          />
        </pattern>
        <image
          id="harcourts_connect_image"
          width={250}
          height={150}
          xlinkHref={harcourtsConnectLogo}
        />
      </defs>
    </svg>
  )
}

export default SvgHarcourtsConnect
